// JS Global
import "@js/global/app";
import "@js/global/sessionHandler";
import "@js/global/collapseState";
import "@js/global/themeToggle";

// JS Contacts
import "@js/contacts/contact-details";
import "@js/contacts/contacts-board";

// JS Campaigns
import "@js/campaigns/campaign_details";
import "@js/campaigns/campaign_view";
import "@js/campaigns/campaign_structure";

// JS Affiliate
import "@js/affiliate/affiliate_list";

// JS Leadsource
import "@js/leadsource/leadsource_list";

// JS Settings
import "./settings/email-templates";
import "./profile/notifications";
import "./dashboard/dashboard";

// Helper
import "@js/helper/messageHelper";
import "@js/helper/formHelper";
import "@js/helper/sortable";
import "@js/helper/qrcode";

// Messaging
import "./messaging/messaging";
import "./websockets/messagingSocket";
import "./websockets/videocallSocket";
import "./websockets/publicVideocallSocket";

// Functions
import "@js/functions/navigation";
import "@js/functions/logout";

// AI Landing Page Generator
import "@js/ai/websiteGenerator";

// Survey Builder
import "@js/survey/surveyBuilder";

// Survey Statistics
import "@js/survey/surveyStatistics";

// JS Volt
import "@js/volt/volt";

import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
window.bootstrap = bootstrap;

import Datepicker from "vanillajs-datepicker/Datepicker";
import de from "vanillajs-datepicker/locales/de";
Object.assign(Datepicker.locales, de);
import Swal from "sweetalert2";
import Choices from "choices.js";

import { TourGuideClient } from "@sjmc11/tourguidejs";
window.TourGuideClient = TourGuideClient;

import { Calendar } from "fullcalendar";
import deLocale from "fullcalendar/locales/de";
import interactionPlugin from "fullcalendar/interaction";
import dayGridPlugin from "fullcalendar/daygrid";
import timeGridPlugin from "fullcalendar/timegrid";
import listPlugin from "fullcalendar/list";
import breezyTheme from "fullcalendar/themes/breezy";

window.FullCalendar = {
  Calendar,
  deLocale,
  dayGridPlugin,
  interactionPlugin,
  timeGridPlugin,
  listPlugin,
  breezyTheme,
};

import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;

import QRCode from "qrcode";

import Chart from "chart.js/auto";
window.Chart = Chart;

import {
  notify,
  notifySuccess,
  notifyError,
  notifyInfo,
  notifyWarning,
  notifyConfirm,
} from "@js/components/notify";

import { connectClaudeSocket, disconnectClaudeSocket } from "@js/websockets/claudeSocket";
import { connectCalendarSocket, disconnectCalendarSocket } from "@js/websockets/calendarSocket";

export {
  Swal,
  Datepicker,
  Choices,
  QRCode,
  notify,
  notifySuccess,
  notifyError,
  notifyInfo,
  notifyWarning,
  notifyConfirm,
  connectClaudeSocket,
  disconnectClaudeSocket,
  connectCalendarSocket,
  disconnectCalendarSocket,
};
